(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["k-cart-upsell"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('k-cart-upsell'))customElements.define('k-cart-upsell',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();
  const signal=this.abort.signal;
  this.rail=this.querySelector('.kupsell__rail');
  this.buttons=[...this.querySelectorAll('[data-upsell-direction]')];
  this.update=()=>{
   const end=this.rail.scrollWidth-this.rail.clientWidth;
   this.buttons[0].disabled=this.rail.scrollLeft<3;
   this.buttons[1].disabled=this.rail.scrollLeft>=end-3;
   this.toggleAttribute('data-can-prev',!this.buttons[0].disabled);
   this.toggleAttribute('data-can-next',!this.buttons[1].disabled);
  };
  this.addEventListener('click',event=>{
   const button=event.target.closest('[data-upsell-direction]');
   if(button&&this.rail.firstElementChild)this.rail.scrollBy({left:Number(button.dataset.upsellDirection)*(this.rail.firstElementChild.getBoundingClientRect().width+12),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   if(event.target.closest('.kupsell__card'))this.interacted=true;
  },{signal});
  this.addEventListener('change',event=>{
   if(!event.target.matches('[data-upsell-size]'))return;
   const input=event.target,card=input.closest('.kupsell__card'),group=input.closest('[data-upsell-option-index]');
   if(event.isTrusted){
    this.interacted=true;
    card.dataset.explicitSelection='true';
    const key=group.dataset.sizeKey;
    if(key==='size'||key==='bralette'){
     try{const choices=JSON.parse(sessionStorage.getItem('kiseau-selected-sizes')||'{}');choices[key]=input.value;sessionStorage.setItem('kiseau-selected-sizes',JSON.stringify(choices));}catch{}
    }
   }
   this.syncCard(card);
  },{signal});
  this.rail.addEventListener('scroll',this.update,{signal,passive:true});
  this.observer=new ResizeObserver(this.update);
  this.observer.observe(this.rail);
  this.update();
  this.disclosure=this.querySelector('.kupsell__disclosure');
  const dialog=this.closest('dialog');
  this.disclosure.open=dialog?.open?dialog.kiseauUpsellOpen!==false:true;
  if(dialog)dialog.kiseauUpsellOpen=this.disclosure.open;
  this.disclosure.addEventListener('toggle',()=>{
   if(!this.isConnected)return;
   if(dialog)dialog.kiseauUpsellOpen=this.disclosure.open;
   if(this.disclosure.open)requestAnimationFrame(()=>{if(this.isConnected)this.update();});
  },{signal});
  this.restoreSizes();
  if(dialog){
   this.visibilityObserver=new MutationObserver(records=>{
    if(!dialog.open){dialog.kiseauUpsellOpen=true;return;}
    if(records.some(record=>record.oldValue===null)){
     this.disclosure.open=true;
     dialog.kiseauUpsellOpen=true;
    }
    this.loadRecommendations(signal);
    requestAnimationFrame(()=>{if(this.isConnected)this.update();});
   });
   this.visibilityObserver.observe(dialog,{attributes:true,attributeFilter:['open'],attributeOldValue:true});
   if(dialog.open)this.loadRecommendations(signal);
  }else this.loadRecommendations(signal);
 }
 restoreSizes(){
  let choices={};
  try{choices=JSON.parse(sessionStorage.getItem('kiseau-selected-sizes')||'{}');}catch{}
  this.querySelectorAll('.kupsell__card').forEach(card=>{
   const variants=JSON.parse(card.dataset.variants||'[]');
   const groups=[...card.querySelectorAll('[data-upsell-option-index]')];
   const preferred=[];
   groups.forEach(group=>{
    const value=choices[group.dataset.sizeKey];
    if([...group.querySelectorAll('[data-upsell-size]')].some(input=>input.value===value))preferred[Number(group.dataset.upsellOptionIndex)]=value;
   });
   const matches=variants.filter(variant=>preferred.every((value,index)=>value===undefined||variant.options[index]===value));
   const selected=matches.find(variant=>variant.available&&!variant.backorder)||matches.find(variant=>variant.available)||matches[0];
   groups.forEach(group=>{
    const index=Number(group.dataset.upsellOptionIndex),value=preferred[index]??selected?.options[index];
    if(value!==undefined)group.querySelectorAll('[data-upsell-size]').forEach(input=>input.checked=input.value===value);
   });
   card.querySelector('form').hidden=false;
   this.syncCard(card);
  });
 }
 syncCard(card){
  const variants=JSON.parse(card.dataset.variants||'[]'),groups=[...card.querySelectorAll('[data-upsell-option-index]')];
  const options=[];
  groups.forEach(group=>{options[Number(group.dataset.upsellOptionIndex)]=group.querySelector('[data-upsell-size]:checked')?.value;});
  const variant=variants.find(candidate=>options.every((value,index)=>candidate.options[index]===value));
  groups.forEach(group=>{
   const index=Number(group.dataset.upsellOptionIndex);
   group.querySelectorAll('[data-upsell-size]').forEach(input=>{
    const matches=variants.filter(candidate=>candidate.options[index]===input.value&&options.every((value,other)=>other===index||candidate.options[other]===value));
    const available=matches.some(candidate=>candidate.available),inStock=matches.some(candidate=>candidate.available&&!candidate.backorder);
    const state=inStock?'in-stock':available?'backorder':matches.length?'sold-out':'missing';
    input.disabled=!available;
    input.setAttribute('aria-label',input.value+(state==='in-stock'?'':' · '+(state==='backorder'?card.dataset.reserveLabel:state==='missing'?card.dataset.missingLabel:card.dataset.soldLabel)));
    input.dataset.available=String(available);
    input.dataset.stock=state;
   });
  });
  const input=card.querySelector('[data-upsell-variant]'),button=card.querySelector('[data-add-button]'),reservation=card.querySelector('[data-upsell-reservation]');
  const available=Boolean(variant?.available),backorder=available&&variant.backorder;
  input.value=variant?.id||'';
  input.disabled=!variant;
  button.disabled=!available||button.closest('form')?.dataset.submitting==='true';
  button.dataset.available=String(available);
  button.textContent=backorder?card.dataset.reserveLabel:available?card.dataset.addLabel:variant?card.dataset.soldLabel:card.dataset.missingLabel;
  button.setAttribute('aria-label',button.textContent+' '+card.dataset.productName);
  reservation.disabled=!backorder;
  const stock=card.querySelector('[data-upsell-stock]');
  stock.textContent=available?'':variant?card.dataset.soldLabel:card.dataset.missingLabel;
  stock.hidden=available;
  if(variant){
   card.querySelector('[data-upsell-price]').textContent=variant.price;
   const compare=card.querySelector('[data-upsell-compare]');
   compare.textContent=variant.compare;
   compare.hidden=!variant.compare;
   card.querySelectorAll('[data-upsell-link]').forEach(link=>{
    const url=new URL(link.href);url.searchParams.set('variant',variant.id);
    if(card.dataset.explicitSelection==='true')url.searchParams.delete('k_auto');
    link.href=url.toString();
   });
  }
 }
 async loadRecommendations(signal){
  if(this.requested)return;
  this.requested=true;
  const ids=[...new Set((this.dataset.productIds||'').split(',').filter(Boolean))].slice(0,4);
  const inCart=new Set((this.dataset.inCart||'').split('|').filter(Boolean));
  this.dataset.recommendationState='loading';
  const results=await Promise.allSettled(ids.map(async id=>{
   const url=new URL(this.dataset.recommendationUrl,document.baseURI);
   url.searchParams.set('product_id',id);
   const response=await fetch(url,{signal,headers:{Accept:'text/html'}});
   if(!response.ok)throw new Error('Recommendations unavailable');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   return [...doc.querySelectorAll('[data-cart-recommendations] .kupsell__card')];
  }));
  if(signal.aborted||!this.isConnected)return;
  const seen=new Set(inCart),cards=[];
  for(const result of results){
   if(result.status!=='fulfilled')continue;
   for(const card of result.value){
    if(!card.dataset.productId||seen.has(card.dataset.productId))continue;
    seen.add(card.dataset.productId);cards.push(card);
    if(cards.length===10)break;
   }
   if(cards.length===10)break;
  }
  if(cards.length&&!this.interacted&&!this.rail.contains(document.activeElement)){
   this.rail.replaceChildren(...cards);
   this.querySelector('[data-upsell-fallback]')?.remove();
   this.dataset.source='shopify-related';
   this.restoreSizes();
   this.update();
  }
  this.dataset.recommendationState='ready';
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.visibilityObserver?.disconnect();this.abort=null;this.requested=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["k-fabric-composition"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('k-fabric-composition'))customElements.define('k-fabric-composition',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;if(matchMedia('(prefers-reduced-motion:reduce)').matches||document.body.dataset.motion==='false'||!('IntersectionObserver' in window))return;this.setAttribute('data-animate','');this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.setAttribute('data-active','');this.observer.disconnect();}},{threshold:.15});this.observer.observe(this);}
 disconnectedCallback(){this.observer?.disconnect();this.removeAttribute('data-animate');this.removeAttribute('data-active');this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["k-fit-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const link=event.target.closest('a[href]');const trigger=event.target.closest('[data-open-fit],[data-size-guide]');if(event.defaultPrevented||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button>0)return;let isFit=Boolean(trigger);if(link){const url=new URL(link.href,location.href);isFit=isFit||(url.origin===location.origin&&/\/pages\/sizing-chart\/?$/.test(url.pathname));}if(!isFit)return;const drawer=document.getElementById('k-fit');if(!drawer)return;event.preventDefault();document.querySelectorAll('.kmega[open],.mobile-nav[open]').forEach(el=>el.open=false);if(!drawer.open){drawer.showModal();drawer.querySelector('[data-close]').focus();}const product=event.target.closest('k-product');if(product){const select=drawer.querySelector('[data-fit-style]');let style=product.dataset.primarySize==='bralette'?'bralette':product.dataset.url.includes('thong')?'thong':product.dataset.url.includes('bikini')?'bikini':'briefs';select.value=style;select.dispatchEvent(new Event('change',{bubbles:true}));}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["k-product-assurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('k-delivery-estimate')) {
  customElements.define('k-delivery-estimate', class extends HTMLElement {
    static get observedAttributes() { return ['data-reservable']; }
    connectedCallback() { this.render(); }
    attributeChangedCallback() { if (this.isConnected) this.render(); }
    addBusinessDays(start, days) {
      const date = new Date(start);
      for (let remaining = days; remaining > 0;) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) remaining--;
      }
      return date;
    }
    render() {
      const guideline = this.dataset.guideline || '';
      if (this.dataset.reservable === 'true') {
        this.textContent = this.dataset.reserveLabel || guideline;
        return;
      }
      const range = guideline.match(/^(\d+)\s*(?:-|–|to)\s*(\d+)\s*(?:bus\.?|business)\s*days?$/i);
      if (!range) { this.textContent = guideline; return; }
      const min = Number(range[1]), max = Number(range[2]);
      if (min < 1 || max < min || max > 90) { this.textContent = guideline; return; }
      const today = new Date();
      today.setHours(12, 0, 0, 0);
      const start = this.addBusinessDays(today, min);
      const end = this.addBusinessDays(today, max);
      const locale = document.documentElement.lang || 'en';
      const format = new Intl.DateTimeFormat(locale, { month:'short', day:'numeric' });
      const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
      this.textContent = min === max ? format.format(start) : format.format(start) + '–' + (sameMonth ? new Intl.DateTimeFormat(locale, { day:'numeric' }).format(end) : format.format(end));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["k-scroll-rail"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('k-scroll-rail'))customElements.define('k-scroll-rail',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.rail=document.getElementById(this.dataset.target);if(!this.rail)return;this.rail.classList.add('k-horizontal-scroll');
  this.abort=new AbortController();const options={signal:this.abort.signal};this.buttons=[...this.querySelectorAll('button')];
  this.update=()=>{const max=this.rail.scrollWidth-this.rail.clientWidth;const left=Math.abs(this.rail.scrollLeft);const media=this.rail.querySelector('.kvoices__media,video,.photo');if(media)this.style.setProperty('--rail-media-height',media.getBoundingClientRect().height+'px');this.hidden=max<4;this.buttons[0].disabled=left<4;this.buttons[1].disabled=left>=max-4;};
  this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(this.rail.matches('.kreviews__viewport'))this.rail.setAttribute('data-manual','');const rtl=getComputedStyle(this.rail).direction==='rtl';this.rail.scrollBy({left:Number(button.dataset.direction)*this.rail.clientWidth*.85*(rtl?-1:1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches||document.body.dataset.motion==='false'?'instant':'smooth'});},options);
  this.rail.addEventListener('scroll',this.update,{...options,passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.rail);const media=this.rail.querySelector('.kvoices__media,video,.photo');if(media)this.observer.observe(media);this.update();
  document.addEventListener('shopify:block:select',event=>{if(this.rail.contains(event.target))event.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});},options);
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.abort=null;}
});
(()=>{
 const selectors='.gallery-thumbs,.style-categories,.kjournal__categories,.kcompare__table-wrap,.kfit__table-wrap,.size-guide-content,.kreviews__viewport';
 let serial=0;
 const enhance=root=>{
  const rows=[...(root.matches?.(selectors)?[root]:[]),...root.querySelectorAll(selectors)];
  rows.forEach(row=>{
   if(row.dataset.scrollEnhanced||row.querySelector('.kfit'))return;
   row.dataset.scrollEnhanced='true';row.classList.add('k-horizontal-scroll');
   if(!row.id)row.id='KHorizontal-'+(++serial);
   const wrap=document.createElement('div');wrap.className='k-horizontal-window';row.before(wrap);wrap.append(row);
   if(!row.hasAttribute('tabindex'))row.tabIndex=0;
   const controls=document.createElement('k-scroll-rail');controls.className='krail';controls.dataset.target=row.id;controls.hidden=true;
   [-1,1].forEach(direction=>{const button=document.createElement('button');button.type='button';button.dataset.direction=direction;button.setAttribute('aria-controls',row.id);button.setAttribute('aria-label',document.body.dataset[direction<0?'scrollPrevious':'scrollNext']||(direction<0?'Previous':'Next'));const icon=document.createElement('span');icon.setAttribute('aria-hidden','true');icon.textContent=direction<0?'←':'→';button.append(icon);controls.append(button);});wrap.append(controls);
  });
 };
 const start=()=>{enhance(document);new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1&&!node.matches('k-scroll-rail'))enhance(node);}))).observe(document.body,{childList:true,subtree:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["k-size-content"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('k-size-experience'))customElements.define('k-size-experience',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;this.select=this.querySelector('[data-fit-style]');this.querySelector('.kfit__select').hidden=false;this.querySelector('.kfit__units').hidden=false;this.select.addEventListener('change',()=>this.showStyle(),{signal});this.addEventListener('click',event=>{const unit=event.target.closest('[data-fit-unit]');if(unit){const cm=unit.dataset.fitUnit==='cm';this.querySelectorAll('[data-fit-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b===unit)));this.querySelectorAll('[data-fit-inches]').forEach(cell=>{const original=cell.dataset.fitInches;cell.textContent=cm?original.replace(/\d+(?:\.\d+)?/g,n=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1}).format(Number(n)*2.54)).replace(/["″]/g,''):original;});this.querySelectorAll('[data-fit-unit-label]').forEach(label=>label.textContent=cm?'(cm)':'(in)');}const size=event.target.closest('[data-fit-size]');if(size){const table=size.closest('table');table.querySelectorAll('[data-fit-size]').forEach(b=>{const active=b===size;b.setAttribute('aria-pressed',String(active));b.closest('tr').toggleAttribute('data-selected',active);});this.querySelector('[data-fit-status]').textContent=Array.from(size.closest('tr').children).map((cell,i)=>`${table.tHead.rows[0].cells[i].textContent}: ${cell.textContent}`).join('. ');}},{signal});this.querySelectorAll('[data-fit-size="M"]').forEach(button=>{button.setAttribute('aria-pressed','true');button.closest('tr').setAttribute('data-selected','');});this.showStyle();}
 showStyle(){const style=this.select.value;this.querySelectorAll('[data-fit-card]').forEach(card=>card.hidden=card.dataset.fitCard!==style);this.querySelectorAll('[data-fit-chart]').forEach(chart=>chart.hidden=chart.dataset.fitChart!==(style==='bralette'?'bralette':'underwear'));}
 disconnectedCallback(){this.abort?.abort();this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["k-system"] && !Shopify.designMode) return;
  try {
    (()=>{
 const root=()=>document.body.dataset.root||'/';
 const words=()=>JSON.parse(document.getElementById('k-language').textContent);
 let cartDismissals=0;
 const invalidateDialog=d=>{if(d?.id==='k-cart')cartDismissals++;if(d?.id==='k-quick')quickProduct.cancel();};
 const closeDialog=d=>{if(d?.open){invalidateDialog(d);d.close();}};
 // Escape and native close() use the same request cleanup as the close button.
 document.addEventListener('cancel',event=>invalidateDialog(event.target),true);
 document.addEventListener('close',event=>{if(!event.target.open)invalidateDialog(event.target);},true);
 const openDialog=d=>{if(d&&!d.open){d.showModal();d.querySelector('input:not([type=hidden]),button')?.focus();}};
 const announce=s=>{const el=document.getElementById('site-status');if(el)el.textContent=s;};
 let busy=false;
 async function refreshCart(open=true,dismissals=cartDismissals){
  const resp=await fetch(root()+'?section_id=k-cart',{headers:{Accept:'text/html'}});
  if(!resp.ok)throw new Error(words().error);
  const doc=new DOMParser().parseFromString(await resp.text(),'text/html');
  const next=doc.querySelector('[data-cart-shell]');const dialog=document.getElementById('k-cart');
  if(!next||!dialog)throw new Error(words().error);
  dialog.replaceChildren(next);
  document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=next.dataset.count;if(el.classList.contains('kheader-count'))el.hidden=Number(next.dataset.count)===0;});
  if(open&&dismissals===cartDismissals)openDialog(dialog);
  document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:{item_count:Number(next.dataset.count)}}}));
 }
 function prepareQuickProduct(product,url){
  if(url)product.dataset.selectionUrl=url;
  const suffix='-quick-'+Date.now();const ids=new Map();product.querySelectorAll('[id]').forEach(e=>{const id=e.getAttribute('id');ids.set(id,id+suffix);e.setAttribute('id',id+suffix);});
  product.querySelectorAll('[for],[form],[aria-controls],[aria-labelledby],[aria-describedby],[data-target]').forEach(e=>{['for','form','aria-controls','aria-labelledby','aria-describedby','data-target'].forEach(name=>{if(e.hasAttribute(name))e.setAttribute(name,e.getAttribute(name).split(' ').map(id=>ids.get(id)||id).join(' '));});});
  product.querySelectorAll('.shopify-app-block,script').forEach(e=>e.remove());return product;
 }

 // One request owner for initial Quick Add and subsequent sibling selections.
 const quickProduct={
  serial:0,
  cancel(){this.serial++;this.controller?.abort();document.querySelector('#k-quick k-product')?.removeAttribute('aria-busy');},
  async load(href,previous){
   this.cancel();const ticket=this.serial,controller=this.controller=new AbortController();
   const dialog=document.getElementById('k-quick'),content=dialog?.querySelector('[data-quick-content]');
   if(!dialog||!content)return;
   const scroll=previous?dialog.scrollTop:0;
   if(previous)previous.setAttribute('aria-busy','true');else{content.textContent=words().loading;openDialog(dialog);}
   const current=()=>ticket===this.serial&&dialog.open&&(!previous||previous.isConnected);
   const timer=setTimeout(()=>controller.abort(),15000);
   try{
    const url=new URL(href,location.href);url.searchParams.delete('section_id');
    const response=await fetch(url,{signal:controller.signal,headers:{Accept:'text/html'}});
    if(!response.ok)throw new Error();
    const doc=new DOMParser().parseFromString(await response.text(),'text/html'),product=doc.querySelector('k-product');
    if(!product)throw new Error();
    if(!current()||controller.signal.aborted)return;
    prepareQuickProduct(product,href);content.replaceChildren(product);dialog.scrollTop=scroll;
    if(previous)product.querySelector('.sibling.selected')?.focus({preventScroll:true});
    announce(product.querySelector('h1')?.textContent||'');
   }catch(error){
    if(!current())return;
    if(previous){const message=previous.querySelector('[data-add-error]');if(message)message.textContent=words().error;}
    else{content.textContent=words().error;const link=document.createElement('a');link.href=href;link.className='button';link.textContent=words().select;content.append(link);}
   }finally{clearTimeout(timer);if(ticket===this.serial)previous?.removeAttribute('aria-busy');}
  }
 };
 function replaceProductHistory(state,url){
  try{history.replaceState(state,'',url);return true;}
  catch(error){if(error.name==='SecurityError'||error.name==='DataCloneError')return false;throw error;}
 }

const productReviewModules = new Map();
async function prepareProductReviews(doc, signal) {
  const check = () => { if (signal?.aborted) throw new DOMException('Navigation cancelled', 'AbortError'); };
  const wait = async promise => {
    check(); let cancel;
    const aborted = new Promise((_, reject) => { cancel = () => reject(new DOMException('Navigation cancelled', 'AbortError')); signal?.addEventListener('abort', cancel, { once: true }); });
    try { return await Promise.race([promise, aborted]); } finally { signal?.removeEventListener('abort', cancel); }
  };
  const selector = '.jdgm-review-widget';
  const targets = Array.from(doc.querySelectorAll('#MainContent ' + selector));
  const records = new Map();
  const scripts = Array.from(doc.querySelectorAll('script:not([src])'), node => node.textContent);
  for (const widget of targets) {
    const id = widget.dataset.productId;
    if (!/^\d+$/.test(id || '') || widget.dataset.widget !== 'review' || widget.dataset.entryPoint !== 'review_widget.js') throw new Error('Unsupported review widget');
    const assignment = new RegExp('\\bjdgm\\.data\\.reviewWidget\\[\\s*[\'\"]?' + id + '[\'\"]?\\s*\\]\\s*=\\s*');
    let data;
    for (const source of scripts) {
      const match = assignment.exec(source); if (!match) continue;
      const start = match.index + match[0].length; let depth = 0, quoted = false, escaped = false;
      if (source[start] !== '{') throw new Error('Invalid review data');
      for (let index = start; index < source.length; index++) {
        const character = source[index];
        if (quoted) { if (escaped) escaped = false; else if (character === '\\') escaped = true; else if (character === '"') quoted = false; continue; }
        if (character === '"') quoted = true;
        else if (character === '{') depth++;
        else if (character === '}' && --depth === 0) { data = JSON.parse(source.slice(start, index + 1)); break; }
      }
      break;
    }
    if (!data || !Array.isArray(data.reviews)) throw new Error('Missing review data');
    records.set(id, data);
  }
  let Manager;
  if (targets.length) {
    if (!window.jdgm || !window.jdgmSettings) throw new Error('Review app is not ready');
    const loader = Array.from(document.querySelectorAll('script[src]'), node => new URL(node.src, location.href)).find(url => url.origin === 'https://cdn.shopify.com' && /^\/extensions\/[\w-]+\/judgeme-[\w-]+\/assets\/loader\.js$/.test(url.pathname));
    if (!loader) throw new Error('Review app loader unavailable');
    const entry = new URL('review_widget.js', loader);
    if (!productReviewModules.has(entry.href)) {
      const load = (async () => {
        const response = await fetch(entry.href, { cache: 'force-cache', credentials: 'omit' });
        if (!response.ok) throw new Error('Review module unavailable');
        const source = await response.text();
        const match = source.match(/import\s*\{\s*ReviewWidgetManager(?:\s+as\s+[\w$]+)?\s*\}\s*from\s*["'](\.\/ReviewWidgetManager-[\w-]+\.js)["']/);
        if (!match) throw new Error('Unsupported review module');
        const managerUrl = new URL(match[1], entry);
        const module = await import(managerUrl.href);
        if (typeof module.ReviewWidgetManager !== 'function') throw new Error('Review manager unavailable');
        return module.ReviewWidgetManager;
      })().catch(error => { productReviewModules.delete(entry.href); throw error; });
      productReviewModules.set(entry.href, load);
    }
    Manager = await wait(productReviewModules.get(entry.href));
  }
  check();
  return {
    beforeReplace() {
      check();
      document.querySelectorAll('#MainContent ' + selector).forEach(widget => widget.__vue_app__?.unmount?.());
      document.querySelectorAll('body > script.jdgm-aggregate-rating-jld').forEach(node => node.remove());
      if (records.size) { window.jdgm.data ||= {}; window.jdgm.data.reviewWidget ||= {}; records.forEach((data, id) => { window.jdgm.data.reviewWidget[id] = data; }); }
    },
    async afterReplace(main) {
      const widgets = Array.from(main.querySelectorAll(selector));
      if (widgets.length !== targets.length) throw new Error('Review widget count changed');
      const badges = Array.from(main.querySelectorAll('k-product .jdgm-preview-badge'));
      const app = window.jdgm; let badgeApiReady = false;
      if (typeof app?.$ === 'function' && app.caches && typeof app.customizeBadges === 'function') {
        app.caches.$revWidgets = app.$(main.querySelectorAll('.jdgm-review-widget,[data-widget="review"]'));
        app.caches.$prevBadges = app.$(document.querySelectorAll('.jdgm-preview-badge'));
        app.caches.$widgetWithReviews = app.$(document.querySelectorAll('.jdgm-review-widget,.jdgm-revs-tab,.jdgm-all-reviews-widget'));
        app.customizeBadges(app.$(badges)); badgeApiReady = true;
      }
      badges.forEach(badge => {
        const content = badge.querySelector('.jdgm-prev-badge');
        if (content && (Number(content.dataset.numberOfReviews) > 0 || !window.jdgmSettings?.hide_badge_preview_if_no_reviews)) content.style.display = 'block';
        if (badgeApiReady) return;
        const stars = badge.querySelector('.jdgm-prev-badge__stars');
        badge.setAttribute('role', 'button'); badge.tabIndex = 0;
        badge.setAttribute('aria-label', [stars?.getAttribute('aria-label'), badge.querySelector('.jdgm-prev-badge__text')?.textContent.trim()].filter(Boolean).join(' · '));
        if (stars) { stars.setAttribute('role', 'img'); stars.removeAttribute('tabindex'); }
        const activate = event => {
          event.preventDefault(); event.stopPropagation();
          const review = widgets.find(widget => widget.dataset.productId === badge.dataset.id);
          if (review) { review.tabIndex = -1; review.focus({ preventScroll: true }); review.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.dataset.motion === 'false' ? 'instant' : 'smooth' }); }
        };
        badge.addEventListener('click', activate, { signal, capture: true });
        badge.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') activate(event); }, { signal, capture: true });
      });
      for (const widget of widgets) {
        check();
        if (!records.has(widget.dataset.productId) || !Manager) throw new Error('Review widget mismatch');
        if (typeof widget.__vue_app__?.unmount === 'function') continue;
        const manager = new Manager(widget); let disposed = false;
        const dispose = () => { if (!disposed && typeof manager.widget?.app?.unmount === 'function') { disposed = true; manager.widget.app.unmount(); } };
        const initialized = Promise.resolve().then(() => manager.initialize()).then(result => {
          if (signal?.aborted || !widget.isConnected) { dispose(); throw new DOMException('Review widget replaced', 'AbortError'); } return result;
        });
        try { await wait(initialized); check(); if (typeof manager.widget?.app?.unmount !== 'function') throw new Error('Reviews did not initialize'); }
        catch (error) { dispose(); throw error; }
      }
    }
  };
}

 // Sibling products use a partial page update; ordinary size choices remain local.
 // Different editorial layouts and unsupported app blocks retain normal navigation.
 const productNavigation = {
  serial: 0,
  pending: false,
  main() { return document.querySelector('#MainContent'); },
  product() { return this.main()?.querySelector('k-product'); },
  owns(url) {
   try { const u = new URL(url, location.href); return u.origin === location.origin && /\/products\/[^/]+\/?$/.test(u.pathname); }
   catch { return false; }
  },
  sectionKey(section) { return section.id.replace(/template--\d+__/, 'template__'); },
  dynamic(section) { return !!section.querySelector('k-product,k-recommendations,.jdgm-review-widget'); },
  fingerprint(section) { return section.outerHTML.replace(/template--\d+__/g, 'template__'); },
  snapshot() {
   const p = this.product();
   return { url: location.href, variant: p?.variant?.id, quantity: p?.querySelector('[name="quantity"]')?.value || '1', x: window.scrollX, y: window.scrollY };
  },
  remember() {
   // A popstate changes the address before the new product has arrived.
   if (this.renderedUrl !== location.href) return;
   const snapshot=this.snapshot();
   if(JSON.stringify(history.state?.kiseauProduct)===JSON.stringify(snapshot))return;
   replaceProductHistory({ ...history.state, kiseauProduct: snapshot }, location.href);
  },
  variantChanged() { this.renderedUrl = location.href; this.remember(); },
  start() {
   if (document.body.dataset.fastProducts !== 'true' || this.started || !this.product()) return;
   this.started = true;
   this.renderedUrl = location.href;
   this.staticSections = new Map(Array.from(this.main().children).filter(s => !this.dynamic(s)).map(s => [this.sectionKey(s), this.fingerprint(s)]));
   this.remember();
   // History writes are limited to two per second during scrolling.
   const queueRemember=()=>{
    if(this.pending||this.rememberTimer)return;
    this.rememberTimer=setTimeout(()=>{this.rememberTimer=null;if(!this.pending)this.remember();},500);
   };
   window.addEventListener('scroll',queueRemember,{passive:true});
   const rememberQuantity = event => {
    if (!this.pending && event.target.matches('[name="quantity"]') && this.product()?.contains(event.target)) this.remember();
   };
   document.addEventListener('input', rememberQuantity);
   document.addEventListener('change', rememberQuantity);
   window.addEventListener('popstate', event => {
    if (!this.owns(location.href)) return;
    this.navigate(location.href, { history: true, saved: event.state?.kiseauProduct });
   });
   window.addEventListener('pagehide', () => {
    clearTimeout(this.rememberTimer);this.rememberTimer=null;this.remember(); this.serial++;
    if (this.pending) this.controller?.abort();
    this.pending = false; this.product()?.removeAttribute('aria-busy');
   });
   window.addEventListener('pageshow', event => {
    if (event.persisted && this.renderedUrl !== location.href && this.owns(location.href)) this.navigate(location.href, { history: true, saved: history.state?.kiseauProduct });
   });
  },
  quantity(product, value) {
   const input = product.querySelector('[name="quantity"]');
   if (!input) return;
   const min = Number(input.min) || 1, max = Number(input.max) || 99, step = Number(input.step) || 1;
   const amount = Math.min(max, Math.max(min, Number(value) || min));
   input.value = String(min + Math.floor((amount - min) / step) * step);
  },
  controls(product) {
   return Array.from(product.querySelectorAll('details.accordion')).map(d => ({ title: d.querySelector('summary')?.textContent.trim(), open: d.open }));
  },
  restoreControls(product, previous, quantity) {
   this.quantity(product, quantity);
   product.querySelectorAll('details.accordion').forEach(d => {
    const old = previous.find(item => item.title === d.querySelector('summary')?.textContent.trim());
    if (old) d.open = old.open;
   });
  },
  metadata(doc) {
   document.title = doc.title;
   const selector = 'link[rel="canonical"],link[rel="alternate"][hreflang],meta[name="description"],meta[property^="og:"],meta[property^="product:"],meta[name^="twitter:"]';
   document.head.querySelectorAll(selector).forEach(n => n.remove());
   doc.head.querySelectorAll(selector).forEach(n => document.head.append(n.cloneNode(true)));
  },
  async navigate(href, options = {}) {
   if (!this.owns(href)) return;
   if (busy && !options.history) return;
   const target = new URL(href, location.href);
   const old = this.product(), main = this.main();
   if (!old || !main) { location.assign(target.href); return; }
   if (!options.history && !this.pending && target.pathname === new URL(this.renderedUrl).pathname && target.searchParams.get('variant') === String(old.variant?.id)) return;
   this.controller?.abort();
   const controller = this.controller = new AbortController(), ticket = ++this.serial;
   this.pending = true;
   old.setAttribute('aria-busy', 'true');
   const timer = setTimeout(() => controller.abort(), 15000);
   let committed = false, fallbackUrl = target.href;
   const kind = ['color', 'style', 'set'].find(k => options.link?.classList.contains('sibling--' + k));
   try {
    const response = await fetch(target.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!response.ok || !this.owns(response.url || target.href)) throw new Error('Product unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextMain = doc.querySelector('#MainContent'), next = nextMain?.querySelector('k-product');
    if (!next || nextMain.querySelectorAll('k-product').length !== 1) throw new Error('No product');
    const returned = new URL(next.dataset.url, location.origin);
    if (returned.pathname.replace(/\/$/, '') !== target.pathname.replace(/\/$/, '')) throw new Error('Product redirected');
    if (!JSON.parse(next.dataset.variants || '[]').length) throw new Error('No variants');
    const oldSections = Array.from(main.children), newSections = Array.from(nextMain.children);
    if (oldSections.length !== newSections.length) throw new Error('Different page layout');
    newSections.forEach((section, index) => {
     const current = oldSections[index];
     const role = node => node.querySelector('k-product') ? 'product' : node.querySelector('.jdgm-review-widget') ? 'reviews' : node.querySelector('k-recommendations') ? 'recommendations' : 'editorial';
     if (role(current) !== role(section) || (!this.dynamic(section) && this.sectionKey(current) !== this.sectionKey(section))) throw new Error('Different page layout');
     if (!this.dynamic(section) && current.id !== section.id && this.staticSections.get(this.sectionKey(section)) !== this.fingerprint(section)) throw new Error('Different editorial content');
    });
    // Do not silently break an app whose lifecycle this theme does not control.
    nextMain.querySelectorAll('.shopify-app-block').forEach(block => {
     if (!block.querySelector('.jdgm-widget')) throw new Error('App needs normal navigation');
    });
    nextMain.querySelectorAll('script').forEach(script => {
     if (['application/ld+json', 'application/json'].includes(script.type)) return;
     if (!script.src && /jdgm\.data\.reviewWidget\[/.test(script.textContent)) return;
     throw new Error('Script needs normal navigation');
    });
    const reviews = await prepareProductReviews(doc, controller.signal);
    if (ticket !== this.serial) return;
    if (controller.signal.aborted) throw new Error('Product request timed out');
    // A historic selection is exact, even if session preferences changed later.
    const selection = new URL(target.href);
    if (options.history && options.saved?.variant) { selection.searchParams.set('variant', options.saved.variant); selection.searchParams.delete('k_auto'); }
    next.dataset.selectionUrl = selection.href;
    next.setAttribute('aria-busy', 'true');
    const quantity = options.history ? options.saved?.quantity : old.querySelector('[name="quantity"]')?.value;
    const accordions = this.controls(old);
    const setStyles = Array.from(old.querySelectorAll('[data-set-style]')).map(select => select.value);
    const anchor = kind && old.querySelector('.sibling--' + kind + '.selected');
    const reference = options.link?.isConnected ? options.link : anchor;
    const top = reference?.getBoundingClientRect().top;
    const position = { x: window.scrollX, y: window.scrollY };
    const restoreFocus = old.contains(document.activeElement);
    if (!options.history) this.remember();
    reviews.beforeReplace();
    // Keep header, cart and unchanged editorial sections mounted.
    newSections.forEach((section, index) => {
     if (!this.dynamic(section)) return;
     section.querySelectorAll('script:not([type="application/ld+json"]):not([type="application/json"])').forEach(s => s.remove());
     oldSections[index].replaceWith(section);
    });
    this.restoreControls(next, accordions, quantity);
    next.querySelectorAll('[data-set-style]').forEach((select, index) => {
     if (Array.from(select.options).some(option => option.value === setStyles[index])) {
      select.value = setStyles[index]; select.dispatchEvent(new Event('change', { bubbles: true }));
     }
    });
    const actual = new URL(target.href);
    if (next.variant) actual.searchParams.set('variant', next.variant.id);
    actual.searchParams.delete('k_auto');
    if (!options.history) history.pushState({ ...history.state, kiseauProduct: { ...this.snapshot(), url: actual.href } }, '', actual.href);
    else history.replaceState({ ...history.state, kiseauProduct: { ...this.snapshot(), url: actual.href } }, '', actual.href);
    this.renderedUrl = actual.href;
    committed = true; fallbackUrl = actual.href;
    this.metadata(doc);
    const focus = kind && next.querySelector('.sibling--' + kind + '.selected');
    if (restoreFocus) {
     const destination = focus || next.querySelector('h1');
     if (destination?.tagName === 'H1') destination.tabIndex = -1;
     destination?.focus({ preventScroll: true });
    }
    const restoreScroll = () => {
     if (ticket !== this.serial) return;
     const y = options.history ? (options.saved?.y ?? position.y) : position.y + (focus && Number.isFinite(top) ? focus.getBoundingClientRect().top - top : 0);
     window.scrollTo({ left: options.history ? (options.saved?.x ?? position.x) : position.x, top: Math.max(0, y), behavior: 'instant' });
    };
    restoreScroll();
    requestAnimationFrame(() => { if (options.history) restoreScroll(); });
    announce(next.querySelector('h1')?.textContent || '');
    document.dispatchEvent(new CustomEvent('kiseau:product:changed', { detail: { productId: next.dataset.productId, variantId: next.variant?.id, url: actual.href } }));
    await reviews.afterReplace(main);
    if (ticket === this.serial) this.remember();
   } catch (error) {
    // An older request must never navigate over the latest selection.
    if (ticket === this.serial) {
     if (options.history || committed) location.replace(fallbackUrl);
     else location.assign(fallbackUrl);
    }
   } finally {
    clearTimeout(timer);
    if (ticket === this.serial) { this.pending = false; this.product()?.removeAttribute('aria-busy'); }
   }
  }
 };

 class KProduct extends HTMLElement{
  connectedCallback(){if(this.bound)return;this.bound=true;
   this.variants=JSON.parse(this.dataset.variants||'[]');this.names=JSON.parse(this.dataset.optionNames||'[]');
   this.select=this.querySelector('[data-variant-id]');this.variant=this.variants.find(v=>String(v.id)===this.select?.value)||this.variants[0];
   this.preferences={};try{this.preferences=JSON.parse(sessionStorage.getItem('kiseau-selected-sizes')||'{}');}catch{}
   const selectionUrl=new URL(this.dataset.selectionUrl||location.href),explicit=selectionUrl.searchParams.has('variant')&&!selectionUrl.searchParams.has('k_auto');
   if(explicit){const selected=this.variants.find(v=>String(v.id)===selectionUrl.searchParams.get('variant'));if(selected)this.variant=selected;this.names.forEach((name,i)=>{const key=this.optionKey(name,this.dataset.primarySize);if(key==='size'||key==='bralette')this.preferences[key]=this.variant.options[i];});this.savePreferences();}
   else this.variant=this.targetVariant(this.variants,this.names,this.dataset.primarySize)||this.variant;
   this.options=this.variant?.options.slice()||[];
   this.querySelector('.variant-chips')?.removeAttribute('hidden');this.querySelector('.variant-fallback')?.setAttribute('hidden','');
   this.addEventListener('click',e=>{if(productNavigation.pending&&this.closest('#MainContent')&&!e.target.closest('[data-sibling]')){e.preventDefault();return;}const quantity=e.target.closest('[data-quantity-step]');if(quantity){const input=quantity.closest('.product-quantity').querySelector('input');if(input.value==='')input.value=1;if(Number(quantity.dataset.quantityStep)>0)input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}const b=e.target.closest('[data-option]');if(b){const index=Number(b.dataset.option);this.options[index]=b.dataset.value;const key=this.optionKey(this.names[index],this.dataset.primarySize);if(key==='size'||key==='bralette'){this.preferences[key]=b.dataset.value;this.savePreferences();}this.update(true);}
    const sibling=e.target.closest('[data-sibling]');if(sibling&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&e.button===0){
     if(this.closest('#k-quick')){e.preventDefault();this.switchQuickSibling(sibling);}
     else if(document.body.dataset.fastProducts==='true'&&productNavigation.owns(sibling.href)){e.preventDefault();productNavigation.navigate(sibling.href,{link:sibling});}

    }
    
    const thumb=e.target.closest('[data-gallery-target]');if(thumb){this.querySelectorAll('[data-media-id]').forEach(x=>x.hidden=x.dataset.mediaId!==thumb.dataset.galleryTarget);}
    const zoom=e.target.closest('[data-zoom]');if(zoom){const d=this.querySelector('.zoom-dialog');d.querySelector('img').src=zoom.dataset.zoom;openDialog(d);}
    if(e.target.closest('[data-notify]')){const d=document.getElementById('k-notify');d.querySelector('[name=variant]').value=this.variant?.id||'';d.querySelector('[data-notify-product]').textContent=this.querySelector('h1').textContent+' · '+this.options.join(' / ');d.querySelector('[data-notify-status]').textContent='';openDialog(d);}
    if(e.target.closest('[data-sticky-buy]')){const button=this.querySelector('[data-add-button]');if(button&&!button.disabled)this.querySelector('form[data-add]').requestSubmit(button);else this.querySelector('.variant-chips').scrollIntoView({behavior:'smooth',block:'center'});}
   });
   this.querySelectorAll('[data-set-style]').forEach(select=>select.addEventListener('change',()=>{select.closest('fieldset').querySelectorAll('[data-bundle-style]').forEach(card=>card.hidden=card.dataset.bundleStyle!==select.value);}));
   this.update(false);
   if(this.closest('#MainContent'))productNavigation.start();
   const buy=this.querySelector('[data-add-button]');const sticky=this.querySelector('.mobile-atc');
   if(buy&&sticky&&!this.closest('#k-quick')){this.observer=new IntersectionObserver(entries=>{const r=entries[0];sticky.hidden=r.isIntersecting;},{threshold:0});this.observer.observe(buy);}
  }
  disconnectedCallback(){this.observer?.disconnect();this.loadController?.abort();}
  switchQuickSibling(link){if(!busy)return quickProduct.load(link.href,this);}
  optionKey(name,primary='size'){const n=name.toLowerCase();return n.includes('bralette')?'bralette':n==='size'?primary:n.includes('size')?'size':n;}
  savePreferences(){try{sessionStorage.setItem('kiseau-selected-sizes',JSON.stringify(this.preferences));}catch{}}
  targetVariant(list,names,primary='size'){const chosen=names.map(n=>this.preferences[this.optionKey(n,primary)]);const hasChoice=chosen.some(o=>o!==undefined);const matches=list.filter(v=>chosen.every((o,i)=>o===undefined||v.options[i]===o));const pool=hasChoice?matches:list;return pool.find(v=>v.available&&!v.backorder)||pool.find(v=>v.available)||pool[0];}
  stockState(variants){return variants.some(v=>v.available&&!v.backorder)?'in-stock':variants.some(v=>v.available)?'backorder':variants.length?'sold-out':'missing';}
  stockLabel(state){return state==='backorder'?this.dataset.stockBackorder:state==='sold-out'?this.dataset.stockSold:state==='missing'?this.dataset.stockMissing:'';}
  updateSiblings(){
   this.querySelectorAll('[data-sibling]').forEach(link=>{const list=JSON.parse(link.dataset.variants||'[]'),names=JSON.parse(link.dataset.optionNames||'[]');const match=this.targetVariant(list,names,link.dataset.primarySize);const state=this.stockState(match?[match]:[]);link.dataset.stock=state;link.classList.toggle('unavailable',state!=='in-stock'&&!link.classList.contains('sibling--style'));const label=link.dataset.label||'';link.setAttribute('aria-label',label+(state==='in-stock'?'':' · '+this.stockLabel(state)));link.title=link.getAttribute('aria-label');const url=new URL(link.href);if(match)url.searchParams.set('variant',match.id);else url.searchParams.delete('variant');url.searchParams.set('k_auto','1');link.href=url.toString();
    const stock=link.querySelector('[data-set-stock]');if(stock){stock.hidden=state==='in-stock';stock.textContent=state==='backorder'?this.stockLabel(state):state==='missing'?this.stockLabel(state):this.dataset.setStockLabel;}const price=link.querySelector('[data-set-price]'),saving=link.querySelector('[data-set-saving]');const v=match||list.find(v=>v.available)||list[0];const low=link.querySelector('[data-set-low-stock]');if(low){const count=match?.inventory;low.hidden=!(state==='in-stock'&&Number.isFinite(count)&&count>0&&count<10);low.textContent=low.hidden?'':this.dataset.lowStock.replace('__count__',count);}if(price&&v)price.textContent=v.price;const compare=link.querySelector('[data-set-compare]');if(compare){compare.hidden=!v?.compare;compare.textContent=v?.compare||'';}if(saving){const override=link.dataset.savingOverride||'';saving.hidden=!(v&&(override||v.savings));saving.textContent=v?(override||(this.dataset.setSavingTemplate||'').replace('__amount__',v.savings).replace('__percent__',v.saving_percent)):'';}
   });
  }
  update(changeUrl){
   this.variant=this.variants.find(v=>v.options.every((o,i)=>o===this.options[i]));const v=this.variant;const reservable=!!(v?.available&&v.backorder);const reserveLabel=this.dataset.reserveLabel||words().backorder;
   this.querySelectorAll('k-delivery-estimate').forEach(el=>el.setAttribute('data-reservable',String(reservable)));
   this.querySelectorAll('[data-reservation-offer]').forEach(el=>{el.hidden=!reservable;});
   this.querySelectorAll('[data-option]').forEach(b=>{const index=Number(b.dataset.option);const selected=this.options[index]===b.dataset.value;b.classList.toggle('selected',selected);b.setAttribute('aria-pressed',String(selected));const matches=this.variants.filter(x=>x.options[index]===b.dataset.value&&x.options.every((o,i)=>i===index||o===this.options[i]));const state=this.stockState(matches);b.dataset.stock=state;b.classList.toggle('unavailable',state!=='in-stock');b.setAttribute('aria-label',(b.dataset.displayValue||b.dataset.value)+(state==='in-stock'?'':' · '+this.stockLabel(state)));b.title=b.getAttribute('aria-label');});
   this.updateSiblings();const status=this.querySelector('[data-selection-stock]');if(status){const state=this.stockState(v?[v]:[]);status.textContent=state==='backorder'?this.stockLabel(state):state==='in-stock'?'':this.stockLabel(state);}

   this.querySelectorAll('[data-option-index]').forEach(f=>{const value=this.options[Number(f.dataset.optionIndex)]||'';const chip=Array.from(f.querySelectorAll('[data-option]')).find(b=>b.dataset.value===value);f.querySelector('[data-option-value]').textContent=chip?.dataset.displayValue||value;});
   const add=this.querySelector('[data-add-button]');if(add){add.dataset.available=String(!!v?.available);add.disabled=!v?.available||add.closest('form')?.dataset.submitting==='true';add.textContent=!v?words().unavailable:reservable?reserveLabel:v.available?words().add:words().sold;}
   if(this.select)this.select.value=v?.id||'';
   this.querySelectorAll('[data-price],[data-sticky-price]').forEach(e=>e.textContent=v?.price||'');this.querySelectorAll('[data-compare]').forEach(e=>e.textContent=v?.compare||'');
   const notify=this.querySelector('[data-notify]');if(notify)notify.hidden=!v||(!v.backorder&&v.available);
   const prop=this.querySelector('[data-backorder-property]');if(prop)prop.disabled=!reservable;
   const sticky=this.querySelector('[data-sticky-buy]');if(sticky){sticky.textContent=reservable?reserveLabel:v?.available?words().add:words().select;sticky.dataset.reservable=String(reservable);}
   if(v&&changeUrl&&!this.closest('#k-quick')&&!productNavigation.pending){const u=new URL(location.href);u.searchParams.set('variant',v.id);u.searchParams.delete('k_auto');replaceProductHistory({...history.state},u);productNavigation.variantChanged();}
  }
 }
 customElements.define('k-product',KProduct);
 customElements.define('k-recommendations',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;const url=this.dataset.url;fetch(url).then(r=>r.text()).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const next=doc.querySelector('k-recommendations .product-grid');if(next?.children.length)this.querySelector('.product-grid').replaceWith(next);else this.hidden=true;}).catch(()=>this.hidden=true);}});
 document.addEventListener('click',async e=>{
  const close=e.target.closest('[data-close]');if(close){e.preventDefault();closeDialog(close.closest('dialog'));return;}
  if(e.target.tagName==='DIALOG'){const b=e.target.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)closeDialog(e.target);}
  if(e.target.closest('[data-open-cart]')){e.preventDefault();try{await refreshCart(true);}catch(err){location.href=root()+'cart';}return;}
  const quick=e.target.closest('[data-quick]');if(quick&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&e.button===0){e.preventDefault();await quickProduct.load(quick.href);return;}
  const swatch=e.target.closest('[data-card-sibling]');if(swatch&&!e.metaKey&&!e.ctrlKey){e.preventDefault();const card=swatch.closest('.card');card.querySelectorAll('.card-media,.card-line a,[data-quick]').forEach(a=>a.href=swatch.href);card.querySelectorAll('.card-swatch').forEach(a=>a.classList.toggle('selected',a===swatch));card.querySelector('.card-line h3 a').textContent=swatch.dataset.title;card.querySelector('.card-line>span').textContent=swatch.dataset.price;card.querySelector('.photo').style.setProperty('--tint',swatch.style.background);if(!card.querySelector('.photo-label')){location.href=swatch.href;}return;}
  const change=e.target.closest('[data-cart-change]');if(change){e.preventDefault();if(busy)return;busy=true;const dismissals=cartDismissals;const shell=change.closest('[data-cart-shell]')||change.closest('[data-cart-page]');shell?.classList.add('busy');try{const r=await fetch(root()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:change.dataset.cartChange,quantity:Number(change.dataset.quantity)})});const data=await r.json();if(!r.ok||data.status)throw new Error(data.description||words().error);if(change.closest('[data-cart-page]'))location.reload();else await refreshCart(true,dismissals);}catch(err){document.querySelector('[data-cart-error]').textContent=err.message;}finally{busy=false;shell?.classList.remove('busy');}return;}
 });
 document.addEventListener('submit',async e=>{
  const form=e.target;if(form.matches('[data-add]')){e.preventDefault();if(busy||(productNavigation.pending&&form.closest('#MainContent')))return;busy=true;const dismissals=cartDismissals;form.dataset.submitting='true';form.setAttribute('aria-busy','true');const button=form.querySelector('[data-add-button]');button.disabled=true;const error=form.querySelector('[data-add-error]');error.textContent='';let added=false;try{const r=await fetch(root()+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const data=await r.json();if(!r.ok||data.status)throw new Error(data.description||words().error);added=true;const container=form.closest('dialog');const upsell=form.closest('k-cart-upsell');if(container?.id!=='k-cart')closeDialog(container);await refreshCart(true,dismissals);if(upsell&&document.getElementById('k-cart')?.open){const next=document.querySelector('#k-cart k-cart-upsell [data-upsell-heading]')||document.querySelector('#k-cart .cart-header button');next?.focus({preventScroll:true});}announce(words().add);document.dispatchEvent(new CustomEvent('product:added',{detail:data}));}catch(err){if(added){location.href=root()+'cart';}else{error.textContent=err.message;error.scrollIntoView({block:'nearest'});}}finally{busy=false;delete form.dataset.submitting;form.removeAttribute('aria-busy');if(button.isConnected)button.disabled=button.dataset.available==='false';}return;}
  if(form.matches('[data-notify-form]')){e.preventDefault();const status=form.querySelector('[data-notify-status]');const button=form.querySelector('button');button.disabled=true;try{const company=document.body.dataset.klaviyo;if(!company)throw new Error(words().error);const r=await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id='+encodeURIComponent(company),{method:'POST',headers:{'Content-Type':'application/vnd.api+json',revision:'2025-01-15'},body:JSON.stringify({data:{type:'back-in-stock-subscription',attributes:{channels:['EMAIL'],profile:{data:{type:'profile',attributes:{email:form.elements.email.value}}}},relationships:{variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::'+form.elements.variant.value}}}}})});if(!r.ok)throw new Error(words().error);status.textContent=words().notify_success;}catch(err){status.textContent=err.message;}finally{button.disabled=false;}}
 });
 document.addEventListener('change',e=>{if(e.target.matches('[data-auto-submit]'))e.target.form.requestSubmit();});
 document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.mobile-nav[open],.country[open],.filters[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
 document.addEventListener('shopify:section:load',()=>{document.querySelectorAll('k-product').forEach(p=>p.connectedCallback());});
})();

(() => {
  let header;
  let observer;
  let frame;
  let lastHeight = -1;
  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const height = Math.ceil(header?.getBoundingClientRect().height || 0);
      if (height === lastHeight) return;
      lastHeight = height;
      document.documentElement.style.setProperty('--kd-header-height', `${height}px`);
    });
  };
  const connect = () => {
    const next = document.querySelector('.k-header-section');
    if (next === header) { update(); return; }
    observer?.disconnect();
    header = next;
    if (header && 'ResizeObserver' in window) {
      observer = new ResizeObserver(update);
      observer.observe(header);
    }
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(connect));
  window.addEventListener('resize', update, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
